<template>
  <div class="def-share">
    <h6 class="def-share__name">
      {{ messages?.share }}
    </h6>
    <div class="def-share-items">
      <a
        v-for="(service, key) in shareLinks"
        :href="service.href"
        class="def-share-item"
        rel="nofollow"
        target="_blank"
      >
        <svg class="def-share-item__icon"><use :xlink:href="`#svg-${key}`"></use></svg>
      </a>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { computed } from 'vue';
import { useProductStore } from '@/storePinia/stores/product';

const productStore = useProductStore();

const messages = computed(() => productStore.messages);
const shareLinks = computed(() => productStore.product?.shareLinks);
</script>

<style lang="scss" scoped>
.def-share {
  display: flex;
  align-items: center;
  gap: 16px;
  &__name {
    font-size: 14px;
    font-weight: 600;
    line-height: 125%;
    text-transform: uppercase;
    margin-bottom: 0;
  }
}
.def-share-items {
  display: inline-grid;
  grid-auto-flow: column;
  grid-column-gap: 24px;
  align-items: center;
}
.def-share-item {
  &:hover {
    svg {
      transform: scale(1.1);
    }
  }
  &__icon {
    display: block;
    height: 24px;
    width: 24px;
    fill: var(--background-black);
    transition: 0.2s linear;
  }
}
</style>
